export const setUntil = ({ until }) => state => {
  return {
    ...state,
    unvisitedPlaces: {
      ...state.unvisitedPlaces,
      until: until || state.until,
    },
  };
};
